import { render, staticRenderFns } from "./EdudashTextarea.vue?vue&type=template&id=1213b045&scoped=true&"
import script from "./EdudashTextarea.vue?vue&type=script&lang=js&"
export * from "./EdudashTextarea.vue?vue&type=script&lang=js&"
import style0 from "./EdudashTextarea.vue?vue&type=style&index=0&id=1213b045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213b045",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
